<template>
  <div class="signinComp">
    <div>
      <h1 class="">Вход</h1>
    </div>
    <div>
      <label class="label_title" for="">{{data.login.title}}</label>
      <input-comp :classInput="'input_orange'" :value="data.login.value" v-model="data.login.value" v-bind:class="{'animated shake error_input': errors.login}" v-on:click.native="resetError('login')"/>
      <p class="p_err_min">{{errors.login}}</p>
    </div>
    <div>
      <label class="label_title" for="">{{data.password.title}}</label>
      <input-comp type="password" :classInput="'input_orange'" :value="data.password.value" v-model="data.password.value" v-bind:class="{'animated shake error_input': errors.password}" v-on:click.native="resetError('password')"/>
      <p class="p_err_min">{{errors.password}}</p>
    </div>
    <div class="div_btns">
      <button-comp textBtn="Войти" classBtn="btn_orange" :clickBtn="signIn"/>
    </div>
    <p class="p_err_main">{{errMain}}</p>
  </div>
</template>

<script>
export default {
  name: 'signinComp',
  data: function () {
    return {
      isLoginErr: false,
      isPasswordErr: false,
      errMessage: null,

      required: null,
      moduleName: 'auth'
    }
  },
  components: {
  },
  props: {
  },
  computed: {
    data: function () { return this.$store.getters[`${this.moduleName}/getModel`] },
    errors: function () { return this.$store.getters[`${this.moduleName}/getErrors`] },
    errMain: function () { return this.$store.getters[`${this.moduleName}/getErrMain`] }
  },
  methods: {
    signIn () {
      this.$store.dispatch(`${this.moduleName}/signIn`, { data: this.data })
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    }
  }
}
</script>

<style scoped lang="scss">

.signinComp{
  width: 350px;
}
.signinComp h1{
  margin: 0 0 64px 0;
  object-fit: contain;
  font-size: 60px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.02;
  letter-spacing: -0.3px;
  color: #202020;
}
.signinComp label{
  object-fit: contain;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #202020;
  float: left;
  margin: 0 0 8px 0;
}
.signinComp input{
  margin: 0 0 16px 0;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
  .signinComp{
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 320px){
  .signinComp h1{
    font-size: 48px;
    margin: 0 0 24px 0;
  }
  .signinComp label{
    margin: 0 0 10px 0;
  }
  .signinComp input{
    margin: 0 0 20px 0;
  }
}
</style>
